<div
  class="position-relative"
  (mouseenter)="cancelCloseMenuAutomatically()"
  (mouseleave)="closeMenuAutomatically()"
  [tooltip]="isOpen() ? '' : dropdownTooltip()"
  [placement]="'bottom'"
  container="body"
>
  <button
    type="button"
    [attr.aria-label]="ariaLabel()"
    [attr.aria-expanded]="isOpen()"
    [attr.aria-haspopup]="true"
    class="btn btn-lg btn-outline-secondary border-0 dropdown-toggle"
    [ngClass]="{ selected: isOpen(), disabled: disabled() }"
    [disabled]="disabled()"
    (click)="isOpen.set(!isOpen())"
  >
    @if (profileImageSource() === '' || !profileImageLoaded()) {
      <div class="rounded-circle profile-icon">
        <div>{{ initials() }}</div>
      </div>
    } @else {
      <img
        class="rounded-circle"
        height="32"
        width="32"
        [src]="profileImageSource()"
        alt=""
        (load)="handleImageLoaded()"
        (error)="handleImageLoadError()"
      />
    }
  </button>

  <div
    class="dropdown-menu dropdown-menu-end p-0 shadow-sm profile-body"
    [ngClass]="{ show: isOpen() }"
  >
    <div class="d-flex flex-column align-items-center p-3 gap-3">
      @if (profileImageSource() === '' || !profileImageLoaded()) {
        <div class="bg-dark rounded-circle profile-icon-lg text-white">
          <div>{{ initials() }}</div>
        </div>
      } @else {
        <img
          class="rounded-circle"
          height="150"
          width="150"
          [src]="profileImageSource()"
          alt=""
        />
      }

      <div class="text-center">
        <h2 class="fw-bold mb-0">{{ firstName() }} {{ lastName() }}</h2>
        <div style="font-size: 0.875rem">{{ email() }}</div>
      </div>
    </div>

    <ng-content select="profile-info"></ng-content>

    <div
      class="d-flex justify-content-between align-items-center bg-light-subtle"
    >
      <button class="btn btn-lg btn-text-primary" (click)="signOut()">
        {{ signOutButtonText() }}
      </button>

      @if (appVersionText()) {
        <span class="app-version-text pe-3">
          {{ appVersionText() }}
        </span>
      }
    </div>
  </div>
</div>
